import { ProductTypes } from 'Types/ProductTypes'
import { CookieHelper } from 'Utils/cookieHelper'
import { useUserStore } from 'Stores/userStoreModuleFed'

type CookieType = (typeof COOKIES)[keyof typeof COOKIES]

const { setCookie, getCookie } = CookieHelper()
const { accountId } = useUserStore.getState()

export const EVENT_PROPERTIES = {
  NAME: 'Banner Dismissed',
  BOTZAPPING_REACHED: 'overages_BM_exceed_warning_dismissed',
  BOTZAPPING_ABOUT_TO_REACH: 'overages_BM_soon_to_exceed_warning_dismissed',
  PAIDMARKETING_REACHED: 'overages_PM_exceed_warning_dismissed',
  PAIDMARKETING_ABOUT_TO_REACH: 'overages_PM_soon_to_exceed_warning_dismissed',
} as const

export const COOKIES = {
  REACHED: 'overages_exceed_warning_dismissed',
  ABOUT_TO_REACH: 'overages_soon_to_exceed_warning_dismissed',
} as const

export const DAYS_IN_MONTH = 30
export const ABOUT_TO_REACH_PERCENTAGE = 80
export const REACHED_PERCENTAGE = 100
const COOKIE_VALUE = 'true'

export const getCookieName = (cookieName: CookieType, product: ProductTypes): string =>
  `banner_close-${cookieName}_${product}_${accountId}`.replace(/ /g, '_').toLowerCase()

export const setBannerCloseCookie = (cookieName: CookieType, product: ProductTypes): void =>
  setCookie(getCookieName(cookieName, product), COOKIE_VALUE, { expires: 34560000, secure: true }) // 34560000 is 400 days the limit time for the cookie

export const wasBannerClosed = (cookieName: CookieType, product: ProductTypes): boolean =>
  getCookie(getCookieName(cookieName, product)) === COOKIE_VALUE
